<template>
  <div class="position-ab">
    <div
      style="margin-bottom: 70px"
      :class="
        confirmStatus == '0'
          ? 'ccui-app-box-iframe-operate-container'
          : 'ccui-app-iframe-no-operate-container'
      "
    >
      <template v-if="labelShow">
        <breadcrumbSourcing
          :breadcrumb-data="breadcrumbData"
        ></breadcrumbSourcing>
        <!--      <div class="detail-info-el-Label">-->
        <!--        <el-label :type="labelType" style="height: 100px;"></el-label>-->
        <!--      </div>-->
      </template>
      <div
        :class="
          confirmStatus == '0'
            ? 'ccui-app-iframe-container-detail'
            : 'ccui-app-iframe-container-no-operate-detail'
        "
      >
        <div class="ccui-app-iframe-container-detail-body">
          <template>
            <template v-if="confirmStatus == '0'">
              <el-tabs class="el-tabs__customize" value="1">
                <el-tab-pane label="确认意见" name="1">
                  <el-form
                    :model="comfirmReasonForm"
                    ref="comfirmReasonForm"
                    label-width="120px"
                  >
                    <el-form-item label="确认意见：">
                      <el-input
                        maxlength="500"
                        show-word-limit
                        placeholder="请输入确认意见"
                        v-model="comfirmReasonForm.comfirmReason"
                        type="textarea"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </template>
            <el-tabs class="el-tabs__customize" value="1">
              <el-tab-pane
                :label="
                  `${
                    purchaseType == 1 ||
                    purchaseType == 4 ||
                    purchaseType == 7 ||
                    purchaseType == 8
                      ? '评审'
                      : '评标'
                  }报告`
                "
                name="1"
              >
                <el-form :model="form" ref="form" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="项目编号：" prop="projectCode">
                        <span>{{ form.projectCode }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="项目名称：" prop="projectName">
                        <span>{{ form.projectName }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="编制人：" prop="agentName">
                        <span>{{ form.agentName }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="评审总结：" prop="textInfo">
                        <span class="text_info" v-html="form.textInfo"></span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-tab-pane>
            </el-tabs>
            <el-tabs class="el-tabs__customize" v-model="active">
              <el-tab-pane label="推荐表" name="1">
                <el-table
                  :data="recommendationTableData"
                  border
                  :span-method="objectSpanMethodRecommendation"
                >
                  <el-table-column
                    prop="id"
                    label="序号"
                    width="55"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="packName"
                    label="包件名称"
                    width="250"
                    v-if="subPackageFlag"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="supName"
                    label="分包商名称"
                    width="250"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="行业类型"
                    width="120"
                    prop="industryTypeName"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    label="企业规模"
                    width="120"
                    prop="companyTypeName"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    prop="taxAmount"
                    label="税额"
                    align="right"
                    min-width="180"
                    show-overflow-tooltip
                  >
                    <template slot-scope="{ row }">
                      <span>{{
                        new BigNumber(row.taxAmount).toFormat(2)
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="noTaxPriceAmount"
                    label="不含税金额"
                    align="right"
                    min-width="180"
                    show-overflow-tooltip
                  >
                    <template slot-scope="{ row }">
                      <span>{{
                        new BigNumber(row.noTaxPriceAmount).toFormat(2)
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="priceAmount"
                    :label="`报价（${moneyData.unit}）`"
                    align="right"
                    width="180"
                    show-overflow-tooltip
                    v-if="purchaseType !== '50' && purchaseType !== '53'"
                  >
                    <template slot-scope="{ row }">
                      <span>{{
                        new BigNumber(row.priceAmount).toFormat(2)
                      }}</span>
                    </template>
                  </el-table-column>
                  <template
                    v-if="
                      evaMethod === '102' ||
                        evaMethod === '103' ||
                        evaMethod === '104'
                    "
                  >
                    <template v-for="(item, index) in columns">
                      <el-table-column
                        :key="index"
                        :label="item.label"
                        :width="item.width"
                        show-overflow-tooltip
                      >
                        <template slot-scope="{ row }">
                          <span>{{ showScore(row[item.prop]) }}</span>
                        </template>
                      </el-table-column>
                    </template>
                    <el-table-column
                      v-if="isOld == 1 && evaMethod != '104'"
                      prop="free4"
                      label="投标报价得分"
                      width="120"
                      show-overflow-tooltip
                    >
                      <template slot-scope="{ row }">
                        {{ new BigNumber(row.free4 || 0).toFormat(2) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="sumScore"
                      v-if="showSum"
                      label="汇总得分"
                      width="120"
                      show-overflow-tooltip
                      ><template slot-scope="{ row }">
                        {{ new BigNumber(row.sumScore || 0).toFormat(2) }}
                      </template></el-table-column
                    >
                  </template>

                  <el-table-column
                    prop="recommendFlagStr"
                    label="是否推荐"
                    width="140"
                    show-overflow-tooltip
                  ></el-table-column>
                  <template
                    v-if="
                      evaMethod === '102' ||
                        evaMethod === '103' ||
                        evaMethod === '104'
                    "
                  >
                    <el-table-column
                      prop="reason"
                      label="说明"
                      width="250"
                      show-overflow-tooltip
                    ></el-table-column>
                  </template>
                  <template v-else>
                    <el-table-column
                      prop="reason"
                      label="说明"
                      show-overflow-tooltip
                    ></el-table-column>
                  </template>
                </el-table>
              </el-tab-pane>
              <!--              <el-tab-pane label="评标报告手签版" name="2">-->
              <!--                <el-table :data="bidEvaluationReportTableData" border>-->
              <!--                  <el-table-column type="index" label="序号" width="55" />-->
              <!--                  <el-table-column-->
              <!--                    prop="fileName"-->
              <!--                    label="附件名称"-->
              <!--                    show-overflow-tooltip-->
              <!--                    width="180"-->
              <!--                  ></el-table-column>-->
              <!--                  <el-table-column prop="fileSize" label="附件大小" width="180">-->
              <!--                    <template slot-scope="{ row }">-->
              <!--                      <span>{{ row.fileSize }}k</span>-->
              <!--                    </template>-->
              <!--                  </el-table-column>-->
              <!--                  <el-table-column-->
              <!--                    show-overflow-tooltip-->
              <!--                    prop="fileSumm"-->
              <!--                    label="附件说明"-->
              <!--                  ></el-table-column>-->
              <!--                  <el-table-column-->
              <!--                    prop="createTime"-->
              <!--                    label="上传时间"-->
              <!--                    width="170"-->
              <!--                  ></el-table-column>-->
              <!--                  <el-table-column label="操作" width="120">-->
              <!--                    <template slot-scope="{ row }">-->
              <!--                      <el-button type="text" @click="download(row)"-->
              <!--                        >下载</el-button-->
              <!--                      >-->
              <!--                    </template>-->
              <!--                  </el-table-column>-->
              <!--                </el-table>-->
              <!--              </el-tab-pane>-->
              <el-tab-pane label="其他附件" name="3">
                <el-table :data="otherFileTableData" border>
                  <el-table-column type="index" label="序号" width="55" />
                  <el-table-column
                    prop="fileName"
                    label="附件名称"
                    show-overflow-tooltip
                    width="180"
                  ></el-table-column>
                  <el-table-column prop="fileSize" label="附件大小" width="180">
                    <template slot-scope="{ row }">
                      <span>{{ row.fileSize }}k</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="fileSumm"
                    show-overflow-tooltip
                    label="附件说明"
                  ></el-table-column>
                  <el-table-column
                    prop="createTime"
                    label="上传时间"
                    width="170"
                  ></el-table-column>
                  <el-table-column label="操作" width="120">
                    <template slot-scope="{ row }">
                      <el-button type="text" @click="download(row)"
                        >下载</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="专家确认记录" name="4">
                <el-table
                  :data="expertTableData"
                  border
                  :span-method="objectSpanMethodResult"
                >
                  <el-table-column
                    prop="round"
                    label="确认轮次"
                    width="100"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="id"
                    label="序号"
                    width="55"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="expertName"
                    label="专家姓名"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="{ $index, row }">
                      <span> {{ row.expertName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="confirmResultStr"
                    label="确认结果"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmOpinion"
                    label="确认意见"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmTime"
                    label="确认日期"
                    width="170"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmStatusStr"
                    label="确认状态"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
      </div>
      <div class="operate">
        <template v-if="confirmStatus === '0'">
          <el-button
            type="text"
            icon="icon-ccui-agree"
            v-preventReClick
            @click="dealBidReportExpertConfirm('1')"
            >同意</el-button
          >
          <el-button
            type="text"
            v-preventReClick
            icon="icon-ccui-disagree"
            @click="dealBidReportExpertConfirm('0')"
            >不同意</el-button
          >
        </template>
        <el-button
          type="text"
          v-preventReClick
          icon="icon-ccui-sharing-o"
          @click="init"
          >刷新</el-button
        >
      </div>
    </div>

    <el-dialog
      title="专家扫描二维码签到"
      @close="innerVisible = false"
      width="360px"
      max-height="400px"
      :visible.sync="innerVisible"
      append-to-body
    >
      <div class="qrcode">
        <h3 style="text-align: center">请使用微信或交建通扫一扫签名</h3>
        <br />
        <!-- 放置二维码的容器,需要给一个ref -->
        <div id="qrcode" ref="qrcode"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  scpQryBidReportDetailApi,
  scpQryFileinfoListApi,
  scpQryBidReportExpertConfirmListApi,
  scpQryBidReportRecommendListApi,
  scpDealBidReportExpertConfirmApi,
  scpQryBidReportExpertConfirmDetailApi,
  selectSchemeVersionById,
  scpQryBidEvaProcessStatusApi,
  scpListPurchaseSchemePackageApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import { addUrlPerFix } from "@/basa/utils";
import QRCode from "qrcodejs2";
import bidEvaProcessStatus from "@/app/subSourcingFlow/mixins/getBidEvaProcessStatus.js";

export default {
  name: "bidEvaluationReportConfirm",
  components: {
    breadcrumbSourcing
  },
  // inject: ["reload"],
  mixins: [bidEvaProcessStatus],
  watch: {
    purchaseType: {
      handler(newVal) {
        if (newVal == 1 || newVal == 4 || newVal == 7 || newVal == 8) {
          this.breadcrumbData.titname = "评审报告编制";
        }
      },
      immediate: true
    },
    innerVisible(newValue, oldValue) {
      if (newValue) {
        // 定时器计算二维码失效
        this.timer = setTimeout(() => {
          this.$message({
            message: "二维码已失效，请重新点击重置签名刷新二维码！",
            type: "eroor",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          this.innerVisible = false;
        }, 300000);
      } else {
        clearTimeout(this.timer);
        this.isSub = true;
        // console.log(this.type, "tttttttt");
        // let title = this.type == 1 ? "签名成功！" : "重置签名成功！";
        // this.$message({
        //   message: title,
        //   type: "success",
        //   duration: 3000,
        //   showClose: true,
        //   ccuiCustom: true,
        // });
        this.init();
      }
    }
  },
  data() {
    return {
      BigNumber: BigNumber,
      innerVisible: false,
      isOld: "",
      showSum: false,
      timer: null,
      showObj: {},
      columns: [],
      type: null,
      breadcrumbData: {
        titname: "评标报告确认",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      moneyData: JSON.parse(sessionStorage.getItem("moneyData")),
      confirmStatus: "", // 1:已确认 0：未确认
      labelShow: false,
      labelType: this.confirmStatus == "0" ? "confirmation" : "confirmed", // 080702  0  未确认 080702  1  已确认
      comfirmReasonForm: {
        comfirmReason: ""
      },
      form: {},
      active: "1",
      expertTableData: [], // 专家确认记录
      recommendationTableData: [], // 推荐表数据
      bidEvaluationReportTableData: [], // 评标报告手签版
      otherFileTableData: [], // 其他附件
      evaMethod: JSON.parse(sessionStorage.getItem("bidEvaPrepareDetailData"))
        .evaMethod, // 评标法 101：最低价评标法  102：综合评标法
      subPackageFlag: true,
      purchaseType: "",
      isSub: false // 是否已经弹出签到二维码
    };
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  created() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    this.getSubPackageFlag();
    this.selectSchemeVersionById();
  },
  methods: {
    init() {
      this.getData();
      // this.reload();
    },
    showScore(num) {
      if (num === null || num === "" || num === undefined) {
        return "-";
      } else {
        return num;
      }
    },
    selectSchemeVersionById() {
      selectSchemeVersionById({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // 是否新单子 1是0不是
        this.isOld = res.data.data.version;
      });
    },
    getSubPackageFlag() {
      scpListPurchaseSchemePackageApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // 是否分包 1分包0不分包
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag =
          res.data.data.subPackageFlag == "1" ? true : false;
      });
    },
    getData() {
      scpQryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        this.labelShow = false;
        this.labelType =
          res.data.data.billStatus === "0" ? "confirmation" : "confirmed"; // 0:确认中 1：已确认
        this.labelShow = true;
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.$set(
          this.breadcrumbData,
          "status",
          JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
            .billStatusName
        );
        this.active = "1";
      });
      scpQryBidReportExpertConfirmDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        evaPurStep: this.$router.history.current.query.evaPurStep,
        purStep: this.$router.history.current.query.menuKey,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId
      }).then(res => {
        if (res.data.code === "0") {
          this.confirmStatus = res.data.data.confirmStatus;
          this.labelType =
            res.data.data.confirmStatus == "0" ? "confirmation" : "confirmed";
          this.labelShow = true;
        }
      });
      // 查看详情
      scpQryBidReportDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.form = res.data.data;
        this.bidReportId = res.data.data.bidReportId;
        // 其他附件
        scpQryFileinfoListApi({
          parentBillId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          billId: this.bidReportId,
          billType: "0807",
          uploadPhase: "0807"
        }).then(res => {
          this.otherFileTableData = JSON.parse(JSON.stringify(res.data.data));
        });
        // 手签版
        scpQryFileinfoListApi({
          parentBillId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          billId: this.bidReportId,
          billType: "080701",
          uploadPhase: "080701"
        }).then(res => {
          this.bidEvaluationReportTableData = res.data.data;
        });
      });
      // 专家确认列表
      scpQryBidReportExpertConfirmListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        bidReportId: this.bidReportId,
        pageNo: -1,
        pageSize: -1
      }).then(res => {
        if (res.data.code === "0") {
          let list = {};
          res.data.data.rows.map(item => {
            list[item.round] = list[item.round] || [];
            list[item.round].push(item);
          });
          let arr = [];
          Object.keys(list).map(key => {
            arr.push(list[key]);
          });
          arr.sort(function(a, b) {
            return a[0].round - b[0].round;
          });
          let devspan = 0;
          let newData = [];
          arr.forEach((item, index) => {
            if (index > 0) {
              devspan += arr[index - 1].length;
            }
            item.forEach((itemtow, indextow) => {
              let obj = {
                id: indextow + 1,
                reportConfirmId: itemtow.reportConfirmId,
                joinExpertId: itemtow.joinExpertId,
                expertName: itemtow.expertName,
                round: itemtow.round,
                confirmResult: itemtow.confirmResult,
                confirmResultStr: itemtow.confirmResultStr,
                confirmOpinion: "",
                confirmTime: itemtow.confirmTime,
                confirmStatus: itemtow.confirmStatus,
                confirmStatusStr: itemtow.confirmStatusStr,
                rowspan: item.length,
                devspan: devspan
              };
              if (itemtow.confirmOpinion == "" && itemtow.confirmResult) {
                if (itemtow.confirmResult == 1) {
                  obj.confirmOpinion = "同意";
                } else {
                  obj.confirmOpinion = "不同意";
                }
              } else {
                obj.confirmOpinion = itemtow.confirmOpinion;
              }
              newData.push(obj);
            });
          });
          this.expertTableData = newData;
        }
      });
      // 推荐表
      scpQryBidReportRecommendListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        if (res.data.code === "0") {
          this.columns = [];
          let data = [];
          let devspan = 0;
          let id = 0;
          let objs = {
            js: false,
            sw: false,
            tb: false
          };
          res.data.data.forEach((item, index) => {
            if (index > 0) {
              devspan += res.data.data[index - 1].sscBidReportSupBOS.length;
            }
            if (item.sscBidReportSupBOS && item.sscBidReportSupBOS.length > 0) {
              if (this.subPackageFlag) {
                id++;
              } else {
                id = 0;
              }
              item.sscBidReportSupBOS.forEach((itemtow, indextow) => {
                if (!this.subPackageFlag) {
                  id++;
                }
                if (itemtow.busiSumScore !== null) {
                  objs.sw = true;
                }
                if (itemtow.techSumScore !== null) {
                  objs.js = true;
                }
                if (itemtow.free4 !== null) {
                  objs.tb = true;
                }
                let obj = {
                  id: id,
                  packName: item.packName,
                  packId: item.packId,
                  scoreSumId: itemtow.scoreSumId,
                  supCode: itemtow.supCode,
                  supName: itemtow.supName,
                  techSumScore: itemtow.techSumScore,
                  busiSumScore: itemtow.busiSumScore,
                  sumScore: itemtow.sumScore,
                  free4: itemtow.free4,
                  priceAmount: itemtow.priceAmount,
                  taxAmount: itemtow.taxAmount,
                  noTaxPriceAmount: itemtow.noTaxPriceAmount,
                  supPackQuoteId: itemtow.supPackQuoteId,
                  supJoinId: itemtow.supJoinId,
                  supQuoteId: itemtow.supQuoteId,
                  recommendFlag: itemtow.recommendFlag,
                  techExtraSumScore: itemtow.techExtraSumScore,
                  busiExtraSumScore: itemtow.busiExtraSumScore,
                  industryTypeName: itemtow.industryTypeName,
                  companyTypeName: itemtow.companyTypeName,
                  recommendFlagStr:
                    itemtow.recommendFlag == "1"
                      ? "推荐"
                      : itemtow.recommendFlag == "0"
                      ? "不推荐"
                      : "-",
                  reason: itemtow.reason,
                  rowspan: item.sscBidReportSupBOS.length,
                  devspan: devspan
                };
                if (
                  obj.sumScore !== undefined &&
                  obj.sumScore !== null &&
                  obj.sumScore !== ""
                ) {
                  this.showSum = true;
                }
                if (
                  obj.techSumScore !== undefined &&
                  obj.techSumScore !== null &&
                  obj.techSumScore !== "" &&
                  !this.columns.some(item => {
                    return item.prop === "techSumScore";
                  })
                ) {
                  this.columns.push({
                    prop: "techSumScore",
                    label: "技术得分",
                    width: 120
                  });
                }
                if (
                  obj.techExtraSumScore !== undefined &&
                  obj.techExtraSumScore !== null &&
                  obj.techExtraSumScore !== "" &&
                  !this.columns.some(item => {
                    return item.prop === "techExtraSumScore";
                  })
                ) {
                  this.columns.push({
                    prop: "techExtraSumScore",
                    label: "技术加分项得分",
                    width: 120
                  });
                }
                if (
                  obj.busiSumScore !== null &&
                  obj.busiSumScore !== undefined &&
                  obj.busiSumScore !== "" &&
                  !this.columns.some(item => {
                    return item.prop === "busiSumScore";
                  })
                ) {
                  this.columns.push({
                    prop: "busiSumScore",
                    label: "商务得分",
                    width: 120
                  });
                }
                if (
                  obj.busiExtraSumScore !== null &&
                  obj.busiExtraSumScore !== undefined &&
                  obj.busiExtraSumScore !== "" &&
                  !this.columns.some(item => {
                    return item.prop === "busiExtraSumScore";
                  })
                ) {
                  this.columns.push({
                    prop: "busiExtraSumScore",
                    label: "商务加分项得分",
                    width: 120
                  });
                }
                data.push(obj);
              });
            }
          });
          this.showObj = objs;
          this.recommendationTableData = data;
        }
      });
    },
    // 推荐表
    objectSpanMethodRecommendation({ row, column, rowIndex, columnIndex }) {
      if (this.subPackageFlag) {
        if (columnIndex < 2) {
          if ((rowIndex - row.devspan) % row.rowspan === 0) {
            return {
              rowspan: row.rowspan,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
    },
    //专家确认列表
    objectSpanMethodResult({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 1) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    download(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid-scp/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    resetSign(type) {
      this.innerVisible = true;
      let qrstr = `${location.protocol}//${
        location.host
      }/scpExpertSign.html?schemeId=${
        JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId
      }&joinExpertId=${
        JSON.parse(sessionStorage.getItem("expertSourceData")).joinExpertId
      }`;
      this.$nextTick(() => {
        document.getElementById("qrcode").innerHTML = "";
        let qrcode = new QRCode(document.getElementById("qrcode"), {
          width: 320,
          height: 280, // 高度
          text: qrstr // 二维码内容
        });
        qrcode.clear(); //清除二维码
        qrcode.makeCode(qrstr); //生成另一个新的二维码
        console.log(qrstr, "qrstr.....");
        this.type = type;
      });
    },
    dealBidReportExpertConfirm(type) {
      if (!this.isSub) {
        this.type = 1;
        this.resetSign(1);
        // return;
      }
      let str = this.comfirmReasonForm.comfirmReason;
      if (!str) {
        if (type == 1) {
          str = "同意";
        } else {
          str = "不同意";
        }
      }
      scpQryBidReportExpertConfirmDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        evaPurStep: this.$router.history.current.query.evaPurStep,
        purStep: this.$router.history.current.query.menuKey,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId
      }).then(res => {
        scpDealBidReportExpertConfirmApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          evaPurStep: this.$router.history.current.query.evaPurStep,
          purStep: this.$router.history.current.query.menuKey,
          reportConfirmId: res.data.data.reportConfirmId,
          confirmResult: type,
          confirmOpinion: str
        })
          .then(res => {
            console.log(res);
            if (res.data.code == "0") {
              this.$message({
                message: `${
                  this.purchaseType == 1 ||
                  this.purchaseType == 4 ||
                  this.purchaseType == 7 ||
                  this.purchaseType == 8
                    ? "评审"
                    : "评标"
                }报告确认成功！`,
                type: "success",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
              this.init();
            }
          })
          .catch(err => {
            console.log(err, "err222222222");
            if (err.data.code == "1") {
              // 弹出扫码电子签名页面
              setTimeout(() => {
                this.type = 1;
                this.resetSign(1);
              }, 1000);
            }
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}
.text_info {
  max-height: 420px;
  width: 100%;
  display: block;
  overflow-y: auto;
}
</style>
